import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

import { Page } from 'shared/ui/Page';

import { MatchDebugTab } from '../../SupplierCatalogJobDetails/ui/MatchDebugTab';

export default () => {
  const { t } = useTranslation();
  const { jobId } = useParams<{ jobId: string }>();
  const [searchParams] = useSearchParams();
  const sku = searchParams.get('sku') || '';

  if (!jobId) {
    return (
      <Page navList={null} navTitle={t('Debug - Job Not Found')}>
        <div>{t('Job ID not found')}</div>
      </Page>
    );
  }

  return (
    <Page navList={null} navTitle={t('SKU Debug - Job {{jobId}}', { jobId })}>
      <MatchDebugTab jobId={jobId} initialSku={sku} />
    </Page>
  );
};
